// extracted by mini-css-extract-plugin
module.exports = {"body":"WelcomeMessage__body___1SrWX"};